// Mock data for gunsmithing business website

export const businessInfo = {
  name: "TayLord Arms",
  tagline: "Expert Craftsmanship, Reliable Service",
  phone: "(843) 209-4304",
  email: "Info.Taylordarms@gmail.com",
  address: "1102 Maplecrest Dr, Moncks Corner, SC 29461",
  hours: {
    weekday: "Mon-Fri: 10:00 AM - 5:00 PM",
    saturday: "Sat: 10:00 AM - 2:00 PM",
    sunday: "Sunday: Closed"
  }
};

export const services = [
  {
    id: 2,
    title: "Repairs & Maintenance",
    description: "Professional repair and cleaning services for all makes and models. We diagnose and fix issues quickly and efficiently.",
    icon: "settings",
    features: ["Cleanings", "Trigger Work", "Barrel Replacement", "General Repairs"]
  },
  {
    id: 5,
    title: "Scope Mounting",
    description: "Professional scope mounting and bore sighting to ensure your optics are properly installed and zeroed.",
    icon: "crosshair",
    features: ["Ring Lapping", "Base Installation", "Bore Sighting", "Torque Specifications"]
  },
  {
    id: 6,
    title: "Restoration",
    description: "Bring new life to antique and vintage firearms with our restoration services while maintaining authenticity.",
    icon: "refresh-cw",
    features: ["Rust Removal", "Wood Refinishing"]
  },
  {
    id: 7,
    title: "Firearms Transfers",
    description: "Licensed FFL transfers for online firearm purchases and private-party sales. We handle all required federal paperwork and background checks with care and professionalism.",
    icon: "clipboard-check",
    features: ["FFL Transfers", "Background Checks", "ATF Form Processing"]
  }
];

export const values = [
  {
    id: 1,
    title: "Honoring Tradition",
    description: "We honor God and the traditional craftsmanship of gunsmithing, preserving time-tested techniques while embracing modern innovations.",
    icon: "shield"
  },
  {
    id: 2,
    title: "Supporting the Second Amendment",
    description: "We are proud supporters of the Second Amendment and the rights of responsible firearm ownership.",
    icon: "flag"
  },
  {
    id: 3,
    title: "Empowering Gun Owners",
    description: "We empower all individuals, regardless of experience level, to own and operate firearms safely and confidently.",
    icon: "users"
  },
  {
    id: 4,
    title: "Restoring Confidence",
    description: "We strive to restore gun ownership interest to those who may have experienced negative interactions elsewhere, providing a welcoming and educational environment.",
    icon: "award"
  }
];


export const pricingCategories = [
  {
    id: 1,
    category: "Cleaning Services",
    description: "Choose between Basic or Advanced cleaning based on your needs. Basic cleaning includes field-strip and hand cleaning of critical components. Advanced cleaning provides complete teardown with ultrasonic treatment for deep precision cleaning.",
    items: [
      { service: "Rifle - Basic Cleaning", price: "$45", type: "basic" },
      { service: "Rifle - Advanced Cleaning & Inspection", price: "$90", type: "advanced" },
      { service: "Shotgun - Basic Cleaning", price: "$40", type: "basic" },
      { service: "Shotgun - Advanced Cleaning & Inspection", price: "$80", type: "advanced" },
      { service: "Pistol - Basic Cleaning", price: "$35", type: "basic" },
      { service: "Pistol - Advanced Cleaning & Inspection", price: "$65", type: "advanced" }
    ]
  },
  {
    id: 2,
    category: "Additional Services",
    items: [
      { service: "Bore Sighting", price: "$25" },
      { service: "Scope Mounting (Standard)", price: "$50" },
      { service: "Precision Zero", price: "$70 + ammo" },
      { service: "Trigger Job", price: "$85+" },
      { service: "Barrel Installation", price: "$125" },
      { service: "Stock Fitting", price: "$100" },
      { service: "Parts Installation", price: "$80/hour" },
      { service: "Custom Work", price: "Quote" }
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "John Mitchell",
    rating: 5,
    text: "Exceptional work on my custom AR build. The attention to detail and craftsmanship is top-notch. Highly recommend!",
    date: "2 weeks ago"
  },
  {
    id: 2,
    name: "Sarah Chen",
    rating: 5,
    text: "Had my grandfather's shotgun restored here. They treated it with the respect it deserved and it looks amazing. Thank you!",
    date: "1 month ago"
  },
  {
    id: 3,
    name: "Mike Rodriguez",
    rating: 5,
    text: "Fast turnaround on my trigger work and the improvement is incredible. Professional service from start to finish.",
    date: "3 weeks ago"
  },
  {
    id: 4,
    name: "David Thompson",
    rating: 5,
    text: "The Cerakote finish on my 1911 is flawless. These guys know what they're doing. Will definitely be back.",
    date: "1 month ago"
  }
];

export const galleryItems = [
  {
    id: 1,
    title: "Q Sugar Weasel Build",
    category: "Custom Build",
    description: "Suppressed 300 BLK rifle with Geissele trigger, Vortex optic, and Dead Air Nomad 30",
    images: [
      "/images/lvvu1kqh_IMG_8711.jpeg",
      "/images/fh9rlpff_IMG_8712.jpeg",
      "/images/lsnbclnt_A588643F-2C49-4A8B-A25C-979112EF14CB.jpeg"
    ]
  },
  {
    id: 2,
    title: "Optics installation and bore sighting",
    category: "Scope Mounting",
    description: "Professional optics installation with precision bore sighting for optimal accuracy",
    images: [
      "/images/uuzu2dbh_IMG_2204.jpeg",
      "/images/plz5nnxn_IMG_2205.jpeg",
      "/images/y80d92og_IMG_2206.jpeg"
    ]
  },
  {
    id: 7,
    title: "Optics Installation - Trijicon AccuPoint 2.5-10x56",
    category: "Scope Mounting",
    description: "Professional installation of Trijicon AccuPoint 2.5-10x56 scope with precision mounting and bore sighting",
    images: [
      "/images/d4jpj4c9_IMG_0415.jpeg",
      "/images/m3zugaoj_IMG_0418.jpeg"
    ]
  },
  {
    id: 8,
    title: "Daniel Defense DDM4V7 - Custom Build",
    category: "Custom Builds",
    description: "Vortex AMG UH-1 sight installation and bore-sighting with Rise Armament RA-535 Advanced-Performance Trigger and Precision Armament M4-72 severe duty compensator",
    images: [
      "/images/bobcpojf_IMG_0421.jpeg",
      "/images/dg5kepfu_IMG_0423.jpeg",
      "/images/gpj656ix_IMG_0425.jpeg"
    ]
  },
  {
    id: 9,
    title: "Springfield Echelon - Pistol Optic & Trigger Installation",
    category: "Pistol Upgrades",
    description: "Holosun green dot installation and Tyrant CNC trigger upgrade on Springfield Echelon",
    images: [
      "/images/zn4y13tf_IMG_0428.jpeg",
      "/images/g8i8926n_IMG_0429.jpeg",
      "/images/ka5odoze_IMG_0430.jpeg"
    ]
  },
  {
    id: 5,
    title: "Precision Rifle - Savage Axis II Precision",
    category: "Custom Builds",
    description: "Installation of Hellfire muzzle brake, Sig Sauer Whiskey Tango 2.5-10x56 scope, extended bolt, and Desh Industries Savage bolt lift kit",
    images: [
      "/images/iim9ab92_IMG_0398.jpeg",
      "/images/ntyj30kc_IMG_0400.jpeg",
      "/images/ki45iytg_IMG_0402.jpeg",
      "/images/jn644f4l_IMG_0399.jpeg"
    ]
  },
  {
    id: 6,
    title: "Shotgun Restoration - Stevens Double-Barreled Shotgun",
    category: "Restoration",
    description: "Before and after photos of Stevens double-barreled shotgun restoration including wood refinishing, metal polishing, and complete restoration",
    images: [
      "/images/jn473pbe_BDCEA9D4-9CEF-4192-B2AC-999306DA95C1.jpeg",
      "/images/xegvdnav_IMG_4DD76E04-FE23-49D4-B3F0-9640E41DB883.jpeg",
      "/images/3ayqmnws_8BA3B968-514F-481B-8E3D-713E5285B05E.jpeg",
      "/images/mnmhgmke_IMG_0409.jpeg",
      "/images/9z98dm6r_IMG_0408.jpeg",
      "/images/w0b1d93d_IMG_0410.jpeg",
      "/images/z9wwgoh9_IMG_0408.jpeg"
    ]
  },
  {
    id: 10,
    title: "Pistol Red Dot Installation - Sig Sauer P320 Legion",
    category: "Pistol Upgrades",
    description: "Vortex Venom red dot installation on a Sig Sauer P320 Legion",
    images: [
      "/images/h2ynxwb7_IMG_0431.jpeg",
      "/images/2fznodjv_IMG_0432.jpeg",
      "/images/kxl42w6t_IMG_0434.jpeg"
    ]
  }
];

export const faqs = [
  {
    id: 1,
    question: "What is your typical turnaround time?",
    answer: "Turnaround times vary by service. Basic services like cleaning and bore sighting can often be completed same-day. Custom builds typically take 4-6 weeks. We'll provide an estimated completion date when you drop off your firearm."
  },
  {
    id: 2,
    question: "Do I need an appointment?",
    answer: "While walk-ins are welcome, we recommend scheduling an appointment to ensure we can give you our full attention and discuss your project in detail."
  },
  {
    id: 3,
    question: "What forms of payment do you accept?",
    answer: "We accept cash, all major credit cards, and checks. Payment is due upon pickup of your firearm."
  },
  {
    id: 4,
    question: "Do you work on all firearm types?",
    answer: "Yes, we service rifles, shotguns, and handguns of all makes and models, both modern and antique."
  }
];

// Store form submissions in localStorage
export const saveContactForm = (formData) => {
  const submissions = JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
  submissions.push({ ...formData, timestamp: new Date().toISOString(), type: 'contact' });
  localStorage.setItem('contactSubmissions', JSON.stringify(submissions));
};

export const saveQuoteRequest = (formData) => {
  const submissions = JSON.parse(localStorage.getItem('quoteRequests') || '[]');
  submissions.push({ ...formData, timestamp: new Date().toISOString(), type: 'quote' });
  localStorage.setItem('quoteRequests', JSON.stringify(submissions));
};
